import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Form, Button, Radio, Modal, Typography, Alert, App, Tooltip, } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import FormModal from 'components/FormModal';
import { adminResetPassword } from 'api/admin/users-api';
import { useSession } from 'components/Authenticated';
import { txt } from 'libs/i18n';
const ResetPasswordForm = ({ userId, onCancel, onRefetch, }) => {
    const [form] = Form.useForm();
    const { session } = useSession();
    const { message } = App.useApp();
    const [resetState, setResetState] = useState({ step: 'idle' });
    const handleSubmit = async () => {
        const method = form.getFieldValue('method');
        const sendEmail = method === 'email';
        setResetState({ step: 'submitting' });
        const result = await adminResetPassword(session.connection, userId, sendEmail);
        if (result.isSuccess()) {
            const { passwordSetupToken } = result.get();
            if (sendEmail) {
                setResetState({ step: 'idle' });
                void message.success(txt('resetPasswordEmailSent'));
                onCancel();
            }
            else if (passwordSetupToken) {
                setResetState({ step: 'token', token: passwordSetupToken, revealed: false });
            }
            else {
                setResetState({ step: 'idle' });
            }
        }
        else {
            setResetState({ step: 'idle' });
            void message.error(txt('unexpectedError'));
        }
    };
    const handleCloseTokenModal = () => {
        setResetState({ step: 'idle' });
        onRefetch === null || onRefetch === void 0 ? void 0 : onRefetch();
        onCancel();
    };
    const isSubmitting = resetState.step === 'submitting';
    const tokenView = resetState.step === 'token' ? resetState : null;
    return (_jsxs(_Fragment, { children: [_jsx(FormModal, { title: txt('resetPassword'), open: true, onCancel: onCancel, footer: [
                    _jsx(Button, { onClick: onCancel, children: txt('cancel') }, "back"),
                    _jsx(Button, { type: "primary", loading: isSubmitting, onClick: () => form.submit(), children: txt('resetPassword') }, "submit"),
                ], children: _jsx(Form, { form: form, initialValues: { method: 'email' }, onFinish: handleSubmit, children: _jsx(Form.Item, { name: "method", label: txt('resetPasswordMethod'), rules: [{ required: true }], children: _jsxs(Radio.Group, { children: [_jsx(Radio, { value: "email", children: txt('resetPasswordSendEmail') }), _jsx(Radio, { value: "token", children: txt('resetPasswordShowToken') })] }) }) }) }), tokenView !== null && tokenView.token !== '' && (_jsxs(Modal, { title: txt('setPasswordTokenTitle'), open: true, footer: [
                    _jsx(Button, { type: "primary", onClick: handleCloseTokenModal, children: txt('close') }, "close"),
                ], onCancel: handleCloseTokenModal, children: [_jsx(Alert, { type: "warning", message: txt('setPasswordTokenWarning'), showIcon: true, style: { marginBottom: 16 } }), _jsx("p", { style: { marginBottom: 8 }, children: txt('setPasswordTokenInstructions') }), _jsxs("div", { style: { display: 'flex', alignItems: 'flex-start', gap: 8 }, children: [_jsx(Typography.Paragraph, { copyable: tokenView.revealed
                                    ? { tooltips: [txt('copyToClipboard'), txt('textCopied')] }
                                    : false, style: { wordBreak: 'break-all', marginBottom: 0, flex: 1 }, children: tokenView.revealed
                                    ? `${window.location.origin}/login/setpassword#token=${encodeURIComponent(tokenView.token)}`
                                    : '••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••••' }), _jsx(Tooltip, { title: txt('revealToken'), children: _jsx(Button, { type: "text", icon: tokenView.revealed ? _jsx(EyeInvisibleOutlined, {}) : _jsx(EyeOutlined, {}), onClick: () => {
                                        setResetState((prev) => (prev.step === 'token'
                                            ? Object.assign(Object.assign({}, prev), { revealed: !prev.revealed }) : prev));
                                    } }) })] })] }))] }));
};
export default ResetPasswordForm;
